import React from "preact/compat";
import { CheckboxField } from './Checkbox.type';

const Checkbox: React.FC<CheckboxField> = ({
  checked,
  className,
  id,
  valText,
  disabled,
  onChange,
  onClick,
}) => {
  return (
    <div className={`d-flex form-check`}>
      <input
        value={valText}
        type="checkbox"
        className={`form-check-input ${className ? className : ''}`}
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        onClick={onClick}
      />
      <label className="form-check-label d-none" for={id}>
        {valText}
      </label>
    </div>
  );
};

export default Checkbox;
